"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgYoutubeWhite = function () {
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.814 5.418c.86.23 1.538.908 1.768 1.768C22 8.746 22 12 22 12s0 3.254-.418 4.814a2.505 2.505 0 0 1-1.768 1.768C18.254 19 12 19 12 19s-6.254 0-7.814-.418a2.505 2.505 0 0 1-1.768-1.768C2 15.254 2 12 2 12s0-3.254.418-4.814c.23-.86.908-1.538 1.768-1.768C5.746 5 12 5 12 5s6.254 0 7.814.418Zm-4.632 6.628-5.227 2.973V9.072l5.227 2.974Z", fill: "#fff" }));
};
exports.default = factorySvgIcon_1.default(SvgYoutubeWhite);
//# sourceMappingURL=SvgYoutubeWhite.js.map